import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import Form, { FormControl } from 'rebook/apps/base/components/form/Form';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import Button from 'rebook/apps/base/components/Button';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


class UnsubscribeView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      isUnSubscribed: false,
      isInProgress: false,
    };
  }

  handleSuccess() {
    this.setState({
      isInProgress: false,
      isUnSubscribed: true,
    });
  }

  handleSubmit(submit) {
    this.setState({
      isInProgress: true,
    });

    const form = validateForm(this.state.form);
    submit(form);
  }

  render() {
    const { isInProgress, isUnSubscribed } = this.state;
    const { user } = this.props;

    if (!user) {
      return <Redirect to={URLS.authForm} />;
    }
    return (
      <div className="section">
        <h1 className={styles.title}>
          Отключение подписки на рассылку
        </h1>
        <div className={styles.container}>
          {!isUnSubscribed && user.email_notifications && (
            <React.Fragment>
              <div className="billetContainer">
                <p className={styles.warn}>
                  Вы действительно хотите отказаться от писем о новинках на свой адрес?
                </p>
                <Form
                  action="/api/account/email-unsubscribe/"
                  extraClassName="jest-userunsubscribe-form"
                  onSuccess={(data) => this.handleSuccess(data)}
                  onSubmit={(callback) => this.handleSubmit(callback)}>
                  <p className={styles.email}>{this.props.user.email}</p>
                  <FormControl>
                    <Button
                      type="submit"
                      extraClassName="jest-userunsubscribe-form-submit"
                      size="small"
                      isInProgress={isInProgress}>
                      Отписаться
                    </Button>
                  </FormControl>
                </Form>
              </div>
              <p className={styles.regret}>Нам жаль, что так получилось</p>
            </React.Fragment>
          )}
          {isUnSubscribed && (
            <React.Fragment>
              <div className="billetContainer jest-success-unsubscribe-text">
                <div className={styles.check} />
                <p className="description">
                  Готово. Новостные рассылки вам больше приходить не будут.
                </p>
              </div>
              <p className={styles.regret}>Нам жаль, что так получилось</p>
            </React.Fragment>
          )}
          {!isUnSubscribed && !user.email_notifications && (
            <div className="billetContainer jest-unsubscribe-text-block">
              <p className={styles.titleForUbsubscribed}>Подписка отключена</p>
              <p className={styles.descriptionForUbsubscribed}>
                Вам не приходят новостные рассылки.
                Но вы всегда сможете включить их обратно в настройках, когда захотите узнать,
                какие еще достойные книги ждут вас в нашей коллекции.
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(UnsubscribeView);
